<template>
  <div class="tinto-page">
    <Loading :isActive="loading" />

    <div class="tinto-aviso">
      <fa-icon icon="info-circle" class="mr-2" />
      O que aconteceu com cada pedido tintométrico depois da liberação: se entrou na máquina, se o
      e-mail dos itens pigmentados saiu — e, quando nada aconteceu, o <strong>motivo</strong>.
    </div>

    <!-- ===== FILTROS ===== -->
    <div class="tinto-filters">
      <div class="tinto-filtros__linha">
        <div class="tinto-filtros__busca">
          <input
            class="form-control"
            v-model="filtros.pedidoId"
            placeholder="Número do pedido (Verso ou ERP)..."
            @keyup.enter="load()"
          />
        </div>
        <div class="tinto-filtros__acoes">
          <button class="button button-primary button--icone" @click="load()" title="Buscar">
            <fa-icon icon="search" />
          </button>
          <button
            :class="['button', 'button--auto', filtrosAbertos ? 'button-primary' : '']"
            @click="filtrosAbertos = !filtrosAbertos"
          >
            <fa-icon icon="filter" /> Filtros
            <span v-if="totalFiltrosAtivos" class="tinto-filtros__contador">{{ totalFiltrosAtivos }}</span>
          </button>
        </div>
      </div>

      <div class="tinto-filtros__painel" v-if="filtrosAbertos">
        <CRow>
          <CCol md="3">
            <div class="tinto-campo">
              <label class="tinto-campo__label">Tipo</label>
              <select class="form-control" v-model="filtros.tipo" @change="load()">
                <option value="">Todos</option>
                <option value="envio_maquina">Envio para a máquina</option>
                <option value="cancelamento_maquina">Cancelamento na máquina</option>
                <option value="email_pigmentados">E-mail de pigmentados</option>
              </select>
            </div>
          </CCol>
          <CCol md="3">
            <div class="tinto-campo">
              <label class="tinto-campo__label">Resultado</label>
              <select class="form-control" v-model="filtros.status" @change="load()">
                <option value="">Todos</option>
                <option value="sucesso">Sucesso</option>
                <option value="falha">Falha</option>
                <option value="ignorado">Não realizado</option>
              </select>
            </div>
          </CCol>
          <CCol md="3">
            <div class="tinto-campo">
              <label class="tinto-campo__label">Origem</label>
              <select class="form-control" v-model="filtros.integracaoId" @change="load()">
                <option value="">Todas</option>
                <option v-for="i in integracoes" :key="i.id" :value="i.id">{{ i.descricao }}</option>
              </select>
            </div>
          </CCol>
          <CCol md="3">
            <div class="tinto-campo">
              <label class="tinto-campo__label">Filial</label>
              <select class="form-control" v-model="filtros.filialId" @change="load()">
                <option value="">Todas</option>
                <option v-for="(nome, id) in filiais" :key="id" :value="id">{{ nome }}</option>
              </select>
            </div>
          </CCol>
          <CCol md="3">
            <div class="tinto-campo">
              <label class="tinto-campo__label">De</label>
              <input class="form-control" type="date" v-model="filtros.dataInicial" @change="load()" />
            </div>
          </CCol>
          <CCol md="3">
            <div class="tinto-campo">
              <label class="tinto-campo__label">Até</label>
              <input class="form-control" type="date" v-model="filtros.dataFinal" @change="load()" />
            </div>
          </CCol>
        </CRow>
      </div>

      <div class="tinto-chips" v-if="chipsFiltros.length">
        <span class="tinto-chips__titulo">Filtrando por</span>
        <span class="tinto-filtro-chip" v-for="chip in chipsFiltros" :key="chip.chave">
          <strong>{{ chip.rotulo }}:</strong> {{ chip.valor }}
          <span class="tinto-filtro-chip__remover" @click="removerFiltro(chip.chave)" title="Remover filtro">&times;</span>
        </span>
        <button class="tinto-chips__limpar" @click="limparFiltros()">limpar tudo</button>
      </div>
    </div>

    <!-- ===== TABELA ===== -->
    <div class="tinto-table-wrap">
      <table class="tinto-table">
        <thead><tr>
          <th style="width:150px">Quando</th>
          <th style="width:120px">Pedido</th>
          <th style="width:90px">Filial</th>
          <th style="width:170px">Acontecimento</th>
          <th style="width:110px">Resultado</th>
          <th style="width:140px">Origem</th>
          <th>Motivo</th>
        </tr></thead>
        <tbody>
          <tr v-if="items.length === 0">
            <td colspan="7" class="tinto-table__empty">Nenhum evento no período</td>
          </tr>
          <tr v-for="evento in items" :key="evento.id">
            <td>{{ evento.datahora | datetime }}</td>
            <td class="tinto-table__primary">
              {{ evento.pedidoErpId || evento.pedidoId }}
              <div v-if="evento.pedidoErpId" class="tinto-table__sub">Orçamento: {{ evento.pedidoId }}</div>
            </td>
            <td>{{ evento.filialId || '—' }}</td>
            <td>{{ rotuloTipo(evento.tipo) }}</td>
            <td>
              <span :class="['tinto-badge', classeStatus(evento.status)]">{{ rotuloStatus(evento.status) }}</span>
            </td>
            <td>
              <span v-if="evento.integracaoNome">{{ evento.integracaoNome }}</span>
              <span v-else class="tinto-table__muted">—</span>
            </td>
            <td>
              <span v-if="evento.motivo">{{ evento.motivo }}</span>
              <span v-else class="tinto-table__muted">—</span>
              <div v-if="detalhesContexto(evento)" class="tinto-table__sub">{{ detalhesContexto(evento) }}</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="tinto-pagination" v-if="paginator.last_page > 1">
      <pagination :data="paginator" :limit="5" @pagination-change-page="load" />
    </div>
  </div>
</template>

<script>
import Loading from "../../components/Loading";
import listagemMixin from "./listagemMixin";

export default {
  name: "tintometrico-eventos",
  components: { Loading },
  mixins: [listagemMixin],
  props: ['integracoes', 'filiais'],

  data() {
    return {
      listagemEndpoint: '/admin/tintometrico/pedido-eventos',
      sort: { by: 'datahora', dir: 'desc' },
      filtros: {
        pedidoId: '', tipo: '', status: '', integracaoId: '', filialId: '', dataInicial: '', dataFinal: '',
      },
      rotulosFiltros: {
        pedidoId: 'Pedido', tipo: 'Tipo', status: 'Resultado', integracaoId: 'Origem',
        filialId: 'Filial', dataInicial: 'De', dataFinal: 'Até',
      },
    };
  },

  methods: {
    appendFiltros(params) {
      Object.entries(this.filtros).forEach(([chave, valor]) => {
        if (valor !== '' && valor !== null) params.append(chave, valor);
      });
    },

    descreverFiltro(chave, valor) {
      if (chave === 'tipo') return this.rotuloTipo(valor);
      if (chave === 'status') return this.rotuloStatus(valor);
      if (chave === 'integracaoId') return this.nomeDaOpcao(this.integracoes, valor);
      if (chave === 'filialId') return (this.filiais || {})[valor] || valor;
      return valor;
    },

    rotuloTipo(tipo) {
      return {
        envio_maquina: 'Envio para a máquina',
        cancelamento_maquina: 'Cancelamento na máquina',
        email_pigmentados: 'E-mail de pigmentados',
      }[tipo] || tipo;
    },

    rotuloStatus(status) {
      return { sucesso: 'Sucesso', falha: 'Falha', ignorado: 'Não realizado' }[status] || status;
    },

    classeStatus(status) {
      if (status === 'sucesso') return 'tinto-badge--success';
      if (status === 'falha') return 'tinto-badge--error';
      return 'tinto-badge--indigo';
    },

    // Resumo do contexto: o que ajuda a entender sem abrir nada.
    detalhesContexto(evento) {
      const ctx = evento.contexto || {};
      const partes = [];

      if (ctx.pedidointegracao_id) partes.push(`venda na máquina: ${ctx.pedidointegracao_id}`);
      if (ctx.itens) partes.push(`${ctx.itens} item(ns)`);
      if (ctx.itens_ignorados) partes.push(`${ctx.itens_ignorados} item(ns) sem cor na máquina`);
      if (Array.isArray(ctx.cores_sem_equivalente)) partes.push(`cores: ${ctx.cores_sem_equivalente.join(', ')}`);
      if (Array.isArray(ctx.filiais_da_integracao)) partes.push(`máquina atende: ${ctx.filiais_da_integracao.join(', ')}`);

      // destinatários: a API grava só a contagem (e-mail é dado pessoal), mas
      // eventos antigos podem carregar a lista de endereços. Qualquer formato
      // inesperado não pode derrubar o render — a linha inteira fica sem patch
      // e o overlay de loading nunca sai da tela.
      if (Array.isArray(ctx.destinatarios)) partes.push(`para: ${ctx.destinatarios.join(', ')}`);
      else if (ctx.destinatarios) partes.push(`${ctx.destinatarios} destinatário(s)`);

      return partes.join(' · ');
    },
  },
};
</script>
